<div class="connect-container" *ngIf="!userServ.isConnected()">
  Connectez-vous pour donner votre avis sur <strong>{{product.name}}</strong><br/>
  <a [routerLink]="route.get('login')" [queryParams]="{redirect: 'product', parse: product.ident}" class="btn green" data-bs-dismiss="modal">Connexion</a>
</div>

<div *ngIf="userServ.isConnected()" [loading]="loading">
  <form class="rating-form-modal" #form="ngForm">
    <gob-message [error]="error" [msg]="msg"></gob-message>

    <div *ngIf="!msg">
      <div class="rating-section mb-4">
        <div class="stars-container">
          <div *ngFor="let i of [].constructor(5); index as ind;" class="star-block">
            <label [for]="'star'+ind" class="star-label">
              <img src="/assets/img/skin/star.png" alt="étoile" [class.active]="ind < rating.rate"/>
            </label>
            <input class="form-check-input custom-radio" [id]="'star'+ind" type="radio" name="star" [value]="ind+1" [(ngModel)]="rating.rate" required />
            <span class="rate-number">{{ind + 1}}</span>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <textarea class="form-control custom-textarea" placeholder="Dites-nous ce que vous avez pensé de ce produit..." name="review" [(ngModel)]="rating.review" required></textarea>
      </div>

      <div class="actions">
        <re-captcha id="recaptcha" name="recaptcha" [(ngModel)]="token" required></re-captcha>
        <button (click)="rate()" 
                type="button" 
                class="btn-submit" 
                [class.disabled]="form.invalid || loading"
                [disabled]="form.invalid || loading">
          Valider mon avis
        </button>
      </div>
    </div>

    <div *ngIf="msg" class="text-center mt-3">
      <button type="button" class="btn green" data-bs-dismiss="modal">Fermer</button>
    </div>
  </form>
</div>